import './styles/featured.css'
import YouTubeAutoPlay from './youtube';

const Featured =()=>{

return(
<section class="featured-projects" id="featured-projects">
  <h2>My Projects</h2>

  <div class="project2">
    <div class="project-details">
      <h3>Finance Tracker Application</h3>
      <p class="subtitle">Finance Tracker Application</p>
      <p>
       The Finance Tracker App is a modern web application designed to help users manage income, 
       track expenses, categorize spending, and gain real-time financial insights. Built with React, 
       it delivers an intuitive, responsive, and interactive experience that makes everyday budgeting effortless.

This project demonstrates your expertise in frontend engineering, state management, 
user-centered UI/UX design, and dynamic data visualization.
      </p>

 

      <div class="buttons">
      <a href="https://finance-tracker-plum-seven.vercel.app/" class="btn live-preview">Live Preview</a>
            </div>
    </div>
 <div className="project-image">
  <YouTubeAutoPlay videoId="vfoVf0DZE_U" />

</div>
  </div>
  <div class="project">
    <div class="project-details">
      <h3>Ecommerce App FrontEnd</h3>
      <p class="subtitle">Ecommerce FrontEnd Application</p>
      <p>
       This is a modern, fully responsive eCommerce frontend application built using React.js 
       and designed to deliver a clean, intuitive, and high-performance shopping experience. 
       The application showcases essential eCommerce features.<br></br>
       <b>Key Features </b> <br></br>

      1. <b>Product Listing Page (PLP):</b>
      Displays products dynamically with images, titles, prices, and category filters. <br></br>

      2. <b>Product Search & Filtering:</b>
      Users can search for products or filter by categories, price range, or keywords.<br></br>

      3. <b>Product Detail Page (PDP):</b>
      Expanded view containing detailed product information, specifications, and images.<br></br>

      4. <b>Shopping Cart System:</b>
      Users can add, remove, increase, or decrease item quantities and see totals update automatically.<br></br>

      5. <b>Responsive UI/UX:</b>
      Fully optimized for mobile, tablet, and desktop using modern layouts and clean visual hierarchy.<br></br>

      <b>Reusable Components:</b><br></br>
      Designed with reusable React components for cards, buttons, modals, loaders, navbars, and more.<br></br>

      <b>Technology Stack</b><br></br>

      1. React.js for component-based UI development<br></br>

      2.React Router for multi-page navigation<br></br>

      3. Context API / Redux (depending on your implementation) for state management<br></br>

      4. CSS <br></br>

      5. Axios / Fetch API for handling API requests
      </p>

 

      <div class="buttons">
      <a href="https://ecommerce-store-kvtm.vercel.app/" class="btn live-preview">Live Preview</a>
            </div>
    </div>
 <div className="project-image">
  <YouTubeAutoPlay videoId="zWWY-4Uj6-g" />

</div>
  </div>

  <div class="project2">
    <div class="project-details">
      <h3>Ecommerce App Backend</h3>
      <p class="subtitle">Ecommerce BackEnd Application</p>
      <p>
       This project is a fully functional e-commerce backend system built with Node.js, Express.js, and MongoDB, 
       designed to 
       power modern online stores with secure data handling and efficient API operations.

The backend provides all essential e-commerce functionalities, including product management, 
user authentication, cart operations, and order processing. It is built with clean architecture
 principles and optimized for scalability and performance
      </p>

 

      <div class="buttons">
      <a href="https://backend-8ivf.onrender.com/" class="btn live-preview">Live Preview</a>
            </div>
    </div>
 <div className="project-image">
  <YouTubeAutoPlay videoId="8NKoMBxMep4" />

</div>
  </div>


  <div class="project">
    <div class="project-details">
      <h3>Inventory App</h3>
      <p class="subtitle">Inventory Management Application</p>
      <p>
       This application revolutionizes inventory tracking by allowing users to effortlessly manage stock levels. Users can log the quantity of products, update totals to reflect current inventory, and make real-time adjustments. Built with a reliable backend using Express.js and Node.js, it ensures efficient processing and seamless operations. Data is securely stored with MongoDB, while the custom-designed CSS interface offers an intuitive and responsive user experience.
This tool demonstrates expertise in backend development, database integration, and UI/UX design, tailored for practical business applications.ging application developed with React, Node.js, and Express. The
        backend features a JWT authentication REST API that connects to a MongoDB database.
      </p>

 

      <div class="buttons">
      <a href="https://inventory-application-project.onrender.com/upload" class="btn live-preview">Live Preview</a>
            </div>
    </div>
    
  <div className="project-image">
  <YouTubeAutoPlay videoId="wlxj__6wKTk" />

</div>

  </div>
  <div class="project2">
    <div class="project-details2">
      <h3>Advanced Job Management Admin Portal</h3>
      <p class="subtitle">Advanced Job Management Admin Portal</p>
      <p>
      

      The Advanced Job Management Admin Portal is a React-based application built to provide administrators with a seamless interface for managing job portals. Using Axios for API communication, the portal streamlines the process of creating and categorizing job listings, defining custom job categories, and overseeing user accounts.

Key features include:<br></br>

<br></br>

1. Job Management: Easily create, update, and delete job postings.
Category Customization: Define and organize jobs into custom categories for better organization.<br></br>

2. User Administration: Manage registered users with options for secure account updates and deletion.<br></br>

3. Data Security: Robust authentication mechanisms ensure user data privacy, leveraging secure password updates and validation.<br></br>

<br></br>The portal demonstrates expertise in frontend development with React, effective API integration with Axios, and user-focused UI/UX design. It is an essential tool for efficient job portal administration.
      </p>

 

      <div class="buttons">
        <a href="https://frontend-blog-api.vercel.app/" class="btn live-preview">Live Preview</a>
      </div>
    </div>
    
  <div className="project-image">
  <YouTubeAutoPlay videoId="8UwA2JdmXpc" />

</div>
  </div>

  <div class="project">
    <div class="project-details2">
      <h3>Job Portal Application</h3>
      <p class="subtitle">Job Portal Application</p>
      <p>

      The frontend of the Advanced Job Management System, built with React, HTML, and CSS, offers a seamless experience for job seekers and recruiters. Using REST APIs, it dynamically fetches and displays up-to-date job listings. Users can filter jobs by categories and view detailed information about each listing with a single click.

The platform’s responsive design ensures compatibility across all devices, providing an intuitive and efficient way to explore opportunities. Whether searching for your next role or showcasing job openings, the system delivers simplicity, speed, and satisfaction.
      </p>

      <div class="buttons">
      <a href="https://frontend-blog-api-users.vercel.app/" class="btn live-preview">Live Preview</a>
       </div>
    </div>
    
  <div className="project-image">
  <YouTubeAutoPlay videoId="U86mlB_SzqU" />

</div>
  </div>

  <div class="project2">
    <div class="project-details2">
      <h3>E-commerce Store</h3>
      <p class="subtitle">E-commerce Store Project</p>
      <p>
      

      This e-commerce store project is a modern web application built with React, showcasing the integration of APIs for dynamic data handling. It uses the Fake Store API to fetch and display product details, demonstrating practical API utilization.

The platform features a clean interface where users can browse products, explore detailed information, and experience a seamless shopping journey. This project highlights the effective combination of React and APIs to deliver a responsive and interactive user experience.
      </p>

 

      <div class="buttons">
        <a href="https://shopping-project-blue.vercel.app/" class="btn live-preview">Live Preview</a>
    
      
      </div>
    </div>
    
  <div className="project-image">
  <YouTubeAutoPlay videoId="AjNS3Cbl22s" />

</div>

  </div>

  <div class="project">
    <div class="project-details">
      <h3>Chat Messenger</h3>
      <p class="subtitle">Chat Messenger</p>
      <p>
      This chatting app is a dynamic web application built with React and powered by a custom backend API. The app enables users to create personalized profiles, complete with profile pictures, social media handles, and additional personal details. Users can connect and exchange messages with other registered account holders, fostering real-time communication.

With a focus on individual profile management, the app showcases seamless integration between frontend and backend systems, offering an intuitive and engaging messaging experience.
      </p>

 

      <div class="buttons">
      <a href="https://messenger-users.vercel.app/" class="btn live-preview">Live Preview</a>
      
      </div>
    </div>
    <div class="project-image">
      <img src={"/chat.PNG"} alt="Blog Application Preview" />
    </div>
  </div>

  <div class="project2">
    <div class="project-details2">
    <h3>Website for Sceptre Chemicals</h3>
      <p class="subtitle">Built with WordPress</p>
      <p>
The Sceptre Chemicals website is a professionally designed platform built with WordPress, tailored to showcase the company's services and expertise. It serves as an informative hub, providing detailed insights into the wide range of chemical solutions offered by Sceptre Chemicals. With a clean and intuitive layout, the website ensures a user-friendly experience, enabling visitors to easily access service information and connect with the company.
      </p>

 
      <div class="buttons">
      <a href="https://sceptrechemicals.org/" class="btn live-preview">Live Preview</a>
      </div>
    </div>
  <div className="project-image">
  <YouTubeAutoPlay videoId="73ekWMr1O1c" />

</div>
  </div>

  <div class="project">
    <div class="project-details">
      <h3>Hola Agro</h3>
      <p class="subtitle">Built with Wordpress</p>
      <p>
      Hola Agro Allied is a leading agro-trading company dedicated to the exportation of premium agricultural products. We pride ourselves on connecting farmers and suppliers to global markets, ensuring the seamless flow of fresh, high-quality produce across borders. With a commitment to excellence, sustainability, and innovation, we aim to strengthen the agricultural value chain while fostering growth and prosperity for all our stakeholders. At Hola Agro Allied, we are passionate about delivering the best of agriculture to the world.
      </p>

 

      <div class="buttons">
      <a href="https://holaagroallied.com.ng/" class="btn live-preview">Live Preview</a>
      </div>
    </div>
    
  <div className="project-image2">
  <YouTubeAutoPlay videoId="Tc_8bQZiis8" />

</div>
  </div>

</section>

    )
}

export default Featured